import React from "react";
import { Drawer, List, Divider } from "@material-ui/core";
import SidebarItem from "./SidebarItem";
import SidebarSectionHeader from "./SidebarSectionHeader";
import { COLORS } from "../styles/theme";
import { LAYOUT_CONFIG } from "../config/layoutConfig";

interface SidebarNavigationProps {
  currentOperation: string;
  onOperationSelect: (operation: string) => void;
}

const SidebarNavigation: React.FC<SidebarNavigationProps> = ({
  currentOperation,
  onOperationSelect,
}) => {
  return (
    <Drawer
      variant="permanent"
      style={{
        width: LAYOUT_CONFIG.SIDEBAR_WIDTH,
        flexShrink: 0,
      }}
      PaperProps={{
        style: {
          width: LAYOUT_CONFIG.SIDEBAR_WIDTH,
          position: "fixed",
          top: LAYOUT_CONFIG.TOP_NAV_HEIGHT + LAYOUT_CONFIG.TOP_SPACING,
          height: `calc(100vh - ${
            LAYOUT_CONFIG.TOP_NAV_HEIGHT + LAYOUT_CONFIG.TOP_SPACING
          }px)`,
          backgroundColor: COLORS.white,
          borderRight: `1px solid ${COLORS.gray200}`,
          overflowY: "auto",
        },
      }}
    >
      <div style={{ padding: "20px 16px 12px 16px" }}>
        <SidebarSectionHeader title="Workflows" />
      </div>

      <List component="nav">
        <SidebarItem
          primary="NewRx Workflow"
          secondary="Create customer, upload to S3, ingest to UPMS, approve or route to follow-up, create order"
          selected={currentOperation === "UNIFIED_NEWRX_WORKFLOW"}
          onClick={() => onOperationSelect("UNIFIED_NEWRX_WORKFLOW")}
        />
        <SidebarItem
          primary="TransferRx Workflow"
          secondary="Create customer, ingest transfer Rx, route to follow-up"
          selected={currentOperation === "UNIFIED_TRANSFERRX_WORKFLOW"}
          onClick={() => onOperationSelect("UNIFIED_TRANSFERRX_WORKFLOW")}
        />
        <SidebarItem
          primary="Renewal Workflow"
          secondary="Create customer, ingest NewRx, ingest renewal, approve or route to follow-up"
          selected={currentOperation === "UNIFIED_RENEWAL_WORKFLOW"}
          onClick={() => onOperationSelect("UNIFIED_RENEWAL_WORKFLOW")}
        />
        <SidebarItem
          primary="RxChangeResponse"
          secondary="Send a prescriber's answer (approve, approve with changes, deny) to a change request"
          selected={currentOperation === "RX_CHANGE_RESPONSE"}
          onClick={() => onOperationSelect("RX_CHANGE_RESPONSE")}
        />
      </List>

      <Divider style={{ margin: "20px 0" }} />

      <div style={{ padding: "12px 16px 12px 16px" }}>
        <SidebarSectionHeader title="NewRx Operations" />
      </div>

      <List component="nav">
        <SidebarItem
          primary="Upload NewRx to S3"
          secondary="Step 1: Upload prescription files to S3 storage"
          selected={currentOperation === "UPLOAD_NEWRX_TO_S3"}
          onClick={() => onOperationSelect("UPLOAD_NEWRX_TO_S3")}
        />
        <SidebarItem
          primary="Ingest NewRx to UPMS"
          secondary="Step 2: Retrieve from S3 and ingest to UPMS"
          selected={currentOperation === "INGEST_NEWRX_TO_UPMS"}
          onClick={() => onOperationSelect("INGEST_NEWRX_TO_UPMS")}
        />
        <SidebarItem
          primary="Approve Prescription / OTC"
          secondary="Step 3: Approve clinical check (CCS) or Rxless OTC (RPH)"
          selected={currentOperation === "APPROVE_PRESCRIPTION"}
          onClick={() => onOperationSelect("APPROVE_PRESCRIPTION")}
        />
        <SidebarItem
          primary="Route to Follow-Up"
          secondary="Step 3 (alternative): Send the prescription to CCS follow-up"
          selected={currentOperation === "ROUTE_TO_FOLLOW_UP"}
          onClick={() => onOperationSelect("ROUTE_TO_FOLLOW_UP")}
        />
        <SidebarItem
          primary="Create Order"
          secondary="Step 4: Create an order for the customer"
          selected={currentOperation === "CREATE_ORDER"}
          onClick={() => onOperationSelect("CREATE_ORDER")}
        />
        <SidebarItem
          primary="Retrieve Rx from S3"
          secondary="Optional: View prescription files from S3"
          selected={currentOperation === "RETRIEVE_RX_FROM_S3"}
          onClick={() => onOperationSelect("RETRIEVE_RX_FROM_S3")}
        />
      </List>

      <Divider style={{ margin: "20px 0" }} />

      <div style={{ padding: "12px 16px 12px 16px" }}>
        <SidebarSectionHeader title="TransferRx Operations" />
      </div>

      <List component="nav">
        <SidebarItem
          primary="Ingest TransferRx to UPMS"
          secondary="Ingest transfer prescriptions to UPMS"
          selected={currentOperation === "INGEST_TRANSFERRX_TO_UPMS"}
          onClick={() => onOperationSelect("INGEST_TRANSFERRX_TO_UPMS")}
        />
        <SidebarItem
          primary="Route to Follow-Up"
          secondary="Send an ingested TransferRx to CCS follow-up"
          selected={currentOperation === "ROUTE_TRANSFERRX_TO_FOLLOW_UP"}
          onClick={() => onOperationSelect("ROUTE_TRANSFERRX_TO_FOLLOW_UP")}
        />
      </List>

      <Divider style={{ margin: "20px 0" }} />
    </Drawer>
  );
};

export default SidebarNavigation;
